import React from "react";
import { useLocation, useNavigate, Link, Navigate } from "react-router-dom";
import { useEffect, useState ,useRef} from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api.js";
import RoomImg from "../../images/new-menu/room.png";
import PickImg from "../../images/new-menu/pickup.png";
import InroomImg from "../../images/new-menu/inroom.png";
import TableImg from "../../images/new-menu/table.png";
import HotelGuideImg from "../../images/new-menu/hotelGuide.png";
import EventImg from "../../images/new-menu/event.png";
import TouristImg from "../../images/new-menu/tourist.png";
import SpaImg from "../../images/new-menu/spa.png";
import HkImg from "../../images/new-menu/housekeeping.png";
import RoomChangeImg from "../../images/other-services/roomchange.svg";
import ReceptionImg from "../../images/other-services/reception.svg";
import WakeCpImg from "../../images/other-services/wakeup.svg";
import FeedBackImg from "../../images/other-services/feedback.svg";
import CheckoutImg from "../../images/other-services/checkout.svg";
import ExtendImg from "../../images/other-services/extend.svg";
import ScrollDown from "../../images/icons/scroll.svg"

import HomeHeader from "../../components/HomeHeader.js";
import ManageDoc from "../../components/ManageDoc.js";
import FeedBack from "../OtherService/FeedBack.js";
import DocModal from "../../components/DocModal.js";
import EarlyCheckin from "../../components/EarlyCheckinModal.js";
import OrderHistory from "../../components/order-history/OrderHistory.js";
import Earlymenu from "../../components/Earlymenu.js";
import RedirectModal from "../../components/RedirectModal.js";
import Skeleton from "../../components/skeletons/skeleton.js";
import CheckoutForm from "../../components/CheckoutForm.js";
import PromotionList from "../promotions/Promotion.js";
import Payment from "../payment/Payment.js";
import CheckOutSuccess from '../../components/alert/CheckOutSuccess.js';
import { fetch_all_propmotions } from "../../actions/promotions/promotion.js";
import { checkRequestStatus } from "../../actions/orderHistory.js";
import RequestCheckAlert from "../../components/alert/RequestCheckAlert.js";
import Copy from '../../images/Copy.svg';
import { messaging } from "../login/firebase/Firebase.js";
import { onMessage } from "firebase/messaging";
import { HomePageView } from "../../utils/Analytics.js";


function Home() {
  const location = useLocation();
  const [hotelDetails, SetHotelDetails] = useState([]);
  const [HotelGuidId, SetHotelGuidId] = useState([]);
  const [IsIndoorDine, SetIndoorDine] = useState(false);
  const [TouristGuide, SetTouristGuide] = useState([]);
  const [HotelEvent, SetHotelEvent] = useState([]);
  const [IsSpa, SetSpa] = useState(false);
  const [IsHotelGuide, SetHotelGuide] = useState(false);
  const [IsHouseKeeping, SetHouseKeeping] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showEarlyCheckin, setShowEarlyCheckin] = useState(false);
  const phone = localStorage.getItem("phone_no");
  const [rating, setRating] = useState(0);
  const [orderHostory, setOrderHostory] = useState(false);
  const [IsFeedbck, SetIsFeedback] = useState(false);
  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const [loading, setLoading] = useState(false);
  const [showCheckOut, setShowCheckOut] = useState(false);
  const [docsToUpload, setDocsToUpload] = useState([]);
  const [isDocUploaded, setIsDocUploaded] = useState([]);
  const [isCheckin, setIsCheckin] = useState(false)
  const [featueList, setFeatueList] = useState(null)
  const [checkOutConformation, setCheckOutConformation] = useState(false);
  const [chechOutLocalStorage, setchechOutLocalStorage] = useState(localStorage.getItem("checkout") ? true : false);
  const [checkOuted, setCheckOuted] = useState( false);
  const [ckeckOutConModal, setckeckOutConModal] = useState(false);
  const appUserId = localStorage.getItem("appUserId");
  // for password copy 
  const [isCopied, setIsCopied] = useState(false);
  const [menuVisibility, setmenuVisibility] = useState(
    {
      IsPickup: 0,
      IsEvent: 0,
      IsFeedback: 0,
      IsIndoorDining: 0,
      IsTable: 0,
      IsHouseKeeping: 0,
      IsSpa: 0,
    })
  const [promotionList, setPromotionList] = useState([]);
  const [requestStatus, setRequestStatus] = useState({earlyCHeckin: false,
                                                      extendStay: false,
                                                      roomChange: false});
  const[requestStatusPopup, setRequestStatusPopup] = useState(false);
  const[statusHeading, setStatusHeading]  =  useState("");  
  
  const requestPermission = () => {
    
    Notification.requestPermission()
      .then((permission) => {
        console.log(permission, "permission");
       if (permission === "denied") {
          alert("Notifications are blocked. Please enable them in browser settings.");
        }
      })
      .catch((error) => {
        console.error("Error requesting notification permission:", error);
      });
  };
  
  
    useEffect(() => {
      requestPermission();
    }, []);;

  useEffect(() => {
    HomePageView();
    console.log(featueList)
    if (featueList) {
      if (isCheckin) {
        setmenuVisibility(prevFormObj => ({
          ...prevFormObj,
          IsPickup: featueList?.Chauffer[1],
          IsEvent: featueList?.Event[1],
          IsFeedback: featueList?.Feedback[1],
          IsIndoorDining: featueList?.IndoorDining[1],
          IsTable: featueList?.Restaurant[1],
          IsHouseKeeping: featueList?.Services[1],
          IsSpa: featueList?.Spa[1],
        }));
      }
      else {
        setmenuVisibility(prevFormObj => ({
          ...prevFormObj,
          IsPickup: featueList?.Chauffer[0],
          IsEvent: featueList?.Event[0],
          IsFeedback: featueList?.Feedback[0],
          IsIndoorDining: featueList?.IndoorDining[0],
          IsTable: featueList?.Restaurant[0],
          IsHouseKeeping: featueList?.Services[0],
          IsSpa: featueList?.Spa[0],
        }));
      }
    }


  }, [isCheckin, featueList])

  var enteredBookingId = "";
  if (urlArray[urlArray.length - 1] !== "home") {
    enteredBookingId = urlArray[urlArray.length - 1];
  }
  const [hasBooking, setHasBooking] = useState("");
  const handleFeedback = () => {
    SetIsFeedback(!IsFeedbck);
  };
  const [earlyTimeArray, setEarlyTimeArray] = useState([]);
  const bookingParams = {
    appUserId: localStorage.getItem("appUserId"),
    reservationId: localStorage.getItem("reservationId"),
    guestId: localStorage.getItem("guestId"),
    hotelId: localStorage.getItem("hotel-id"),
    hotelDetails: hotelDetails,
  };

  const [reservationDetails, setReservationDetails] = useState([]);

  let hotelId = localStorage.getItem("booking-id") || "";

  const getHotelFeature = async (data, firebase) => {
    setLoading(firebase ? false : true);

    try {
      const response = await axios({
        method: "post",
        url: `${baseURL}/api/bookingIdV21`,
        data,
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.success) {
        const hotelData = response.data.data;
        const { hotelDetails, hotelFeatures, reservationDetails, guestDetails } = hotelData;

        // Set state from the API response
        setFeatueList(hotelFeatures);
        setIsCheckin(reservationDetails?.checkedIn);
        setLoading(false);
        setReservationDetails(reservationDetails);
        SetHotelDetails(hotelDetails);
        SetHotelGuidId(hotelDetails);
        SetIndoorDine(hotelFeatures.IndoorDining);
        SetSpa(hotelFeatures.Spa);
        SetTouristGuide(hotelFeatures.TouristGuide);
        SetHotelEvent(hotelFeatures.Event);
        setEarlyTimeArray(hotelDetails.earlyCheckin);
        setDocsToUpload(hotelData.documentsToBeUploaded);
        setIsDocUploaded(guestDetails?.docUploaded);
        setchechOutLocalStorage(reservationDetails.is_pre_checkout);

        // Update localStorage in bulk
        const hotelDetailsToStore = {
          "hotelCurrency": hotelDetails.currency,
          "guestWebEarlyCheckin": JSON.stringify(hotelDetails.earlyCheckin),
          "hotelDetailsGuestWeb": JSON.stringify(hotelDetails),
          "guestDetailsArray": JSON.stringify(reservationDetails),
          "guestId": guestDetails.guestId,
          "reservationId": reservationDetails.reservationId,
          "hotel-id": hotelDetails.hotelId,
          "booking-id": reservationDetails.bookingId,
          "isCheckedIn": reservationDetails.checkedIn,
          "checkout": reservationDetails.is_pre_checkout,
          "restrictHotelListFlag": 1,
        };

        Object.entries(hotelDetailsToStore).forEach(([key, value]) => {
          localStorage.setItem(key, value);
        });
      } else {
        navigate("../hotel-list");
        localStorage.removeItem("restrictHotelListFlag");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching hotel details:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  
    const phoneNo = localStorage.getItem("phone_no");
    const guestEmail = localStorage.getItem("guest_email");
  
    // Redirect if no phone or email in localStorage
    if (!phoneNo && !guestEmail) {
      navigate("../");
      return;
    }
  
    if (!location.state && !hotelId) {
      navigate("/");
      return;
    }
  
    const mobileNumber = phoneNo;
    const email = guestEmail;
    let data;
  
    if (mobileNumber) {
      data = {
        bookingId: location.state?.bookingId || localStorage.getItem("booking-id"),
        mobileNumber,
      };
    } else if (email) {
      data = {
        bookingId: hotelId,
        email,
      };
    }


  if (location.state?.data) {
    // If location.state.data exists, directly set the state from location.state
    const { hotelFeatures, reservationDetails, hotelDetails, guestDetails } = location.state.data;
    setFeatueList(hotelFeatures);
    setIsCheckin(reservationDetails?.checkedIn);
    setReservationDetails(reservationDetails);
    SetHotelDetails(hotelDetails);
    SetHotelGuidId(hotelDetails);
    SetIndoorDine(hotelFeatures.IndoorDining);
    SetSpa(hotelFeatures.Spa);
    SetTouristGuide(hotelFeatures.TouristGuide);
    SetHotelEvent(hotelFeatures.Event);
    setEarlyTimeArray(hotelDetails.earlyCheckin);
    setDocsToUpload(location.state.data.documentsToBeUploaded);
    setIsDocUploaded(guestDetails?.docUploaded);
    setchechOutLocalStorage(reservationDetails?.is_pre_checkout);

    // Optionally, update localStorage from location.state
    const hotelDetailsToStore = {
      "hotelCurrency": hotelDetails.currency,
      "guestWebEarlyCheckin": JSON.stringify(hotelDetails.earlyCheckin),
      "hotelDetailsGuestWeb": JSON.stringify(hotelDetails),
      "hotelFeaturesGuestWeb": JSON.stringify(hotelFeatures),
      "guestDetailsArray": JSON.stringify(reservationDetails),
      "documentsToBeUploaded": JSON.stringify(location.state.data.documentsToBeUploaded),
      "guestData": JSON.stringify(guestDetails),
      "guestId": guestDetails.guestId,
      "reservationId": reservationDetails.reservationId,
      "hotel-id": hotelDetails.hotelId,
      "isCheckedIn": reservationDetails.checkedIn,
      "booking-id": reservationDetails.bookingId,
      "checkout": reservationDetails.is_pre_checkout,
      "restrictHotelListFlag": 1,
    };

    Object.entries(hotelDetailsToStore).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  } else {
   

    getHotelFeature(data); 
    
  }

   onMessage(messaging, (payload) => {
      console.log(payload?.data?.notification);
      if (payload?.data?.notification === 'CheckedIn') {
        getHotelFeature(data, true); // Refetch the hotel details when 'CheckedIn' notification is received
        setCheckOuted(false);
      }else if(payload?.data?.notification === 'checkOutRequest'){
        setCheckOuted(true);
        setchechOutLocalStorage(true);
      }
    });
}, []);


  useEffect(()=>{
  if(hotelDetails?.hotelId){
     fetchPromotions()
  }
  if(reservationDetails?.reservationId){
    getRequestStatus();
  }
  },[hotelDetails, reservationDetails])

   

  const fetchPromotions = async () => {
    try {
      const res = await fetch_all_propmotions(hotelDetails?.hotelId);
      if (res.data?.success) {
        const isCheckedIn = localStorage.getItem("isCheckedIn"); 
        const filteredPromotions = res.data?.data.filter((item) => {
          if (isCheckedIn === "true") { 
            return item.status[1] === 1; 
          } else {
            return item.status[0] === 1 || item.status[2] === 1;
          }
        });
         setPromotionList(filteredPromotions);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getRequestStatus = async () => {
    try {
      const res = await checkRequestStatus(reservationDetails?.reservationId, appUserId);
      console.log(res)
      if (res.success) {
       setRequestStatus(res?.data)
      }
    } catch (e) {
      console.log(e);
    }
  };

 

  // useEffect(() => {
  //   // Handler for popstate event (back button pressed)
  //   const handlePopState = (event) => {
  //     alert('Back button was pressed.');
  //     console.log(
  //       `location: ${document.location}, state: ${JSON.stringify(event.state)}`
  //     );
  //   };

  //   // Add event listener for popstate
  //   window.addEventListener('popstate', handlePopState);

  //   // Push initial state once, for example
  //   window.history.pushState({ page: 1 }, "Initial", document.location);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener('popstate', handlePopState);
  //   };
  // }, []);

  const handleCloseCheckOutSuccess = () => {
    localStorage.removeItem("restrictHotelListFlag");
    localStorage.removeItem("restrictHomePageFlag");
    navigate("../hotel-list");
    setCheckOutConformation(false);
  }
  const handleCloseConModal = () => {
    setckeckOutConModal(false);
  }


  const handleRoomChangeCheck = async (requestName)=>{
    try {
      const res = await checkRequestStatus(reservationDetails?.reservationId, appUserId);
       console.log( res.success)

      if (res.success) {
        console.log("object")
        if(!res?.data?.roomChange) {
         
          if(chechOutLocalStorage){
            setckeckOutConModal(true)
          }else{
             handleServiceAlert("Room change")
          }
        } else{
          navigate('../room-change');
        }
      }
    } catch (e) {
      console.log(e);
    }                   
  }

  const handleExtendStayStatus = async()=>{
    try {
      const res = await checkRequestStatus(reservationDetails?.reservationId, appUserId);
      console.log(res)
        

        if (res.success) { 
          if(res?.data?.extendStay) {
            if(chechOutLocalStorage){
              setckeckOutConModal(true)
            }else{
               handleServiceAlert("Extend stay")
            }
          } else{
            navigate('../extend-stay');
          }
        } 
    } catch (e) {
      console.log(e);
    } 
  }

  const handleEarlyCheckinStatus = async()=>{
     try {
      const res = await checkRequestStatus(reservationDetails?.reservationId, appUserId);
      console.log(res)
      if (res.success) {
        if(res?.data?.earlyCHeckin) {
          handleServiceAlert("Early Check-in");
        }else{
          setShowEarlyCheckin(true);
        }
      }
    } catch (e) {
      console.log(e);
    } 
  }
  const handleServiceAlert = (requestName)=>{
    console.log(requestName)
    setRequestStatusPopup(true);
    setStatusHeading(`${requestName} is already requested`)
  }
      console.log("SetHotelDetails",hotelDetails.wifiPassword)   
      
      const handleCopyClick = () => {
        if (hotelDetails.wifiPassword) {
          navigator.clipboard.writeText(hotelDetails.wifiPassword)
            .then(() => {
              setIsCopied(true);  // Set to 'Copied' after copying
              setTimeout(() => setIsCopied(false), 2000);  // Reset the state after 2 seconds
            })
            .catch(err => {
              console.error("Failed to copy text: ", err);
            });
        }
      };

      // sroll arrow 
      const [showArrow, setShowArrow] = useState(true);

      useEffect(() => {
        const handleScroll = () => {
          const scrollTop = window.scrollY;
          // console.log('scrollTop:', scrollTop);
          if (scrollTop >= 100) {
            setShowArrow(false); // Hide the arrow
          } else {
            setShowArrow(true); // Show the arrow
          }
        };
    

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []); 

      const scrollToBottom = () => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      };

    
  return (
    <div className="home-page relative">
      {!loading ? (
        <div >
          <HomeHeader
            hotelDetails={hotelDetails}
            reservationDetails={reservationDetails}
            showOrderHostory={() => setOrderHostory(true)}
            checkOuted={checkOuted}
          />
           {(!reservationDetails.checkedIn || chechOutLocalStorage) &&
            <div className="checkin-info text-center left-0 w-full mt-2" >
              {chechOutLocalStorage && !checkOuted &&  "Pre Check-out Requested"}
              { checkOuted &&  "Checked-out"}
              {!reservationDetails.checkedIn && !chechOutLocalStorage && "Use Hotel Services before arriving at the hotel"}
              </div>}
          <div
            className="section-wrap mt-2"
          >
              {hotelDetails.wifiPassword && reservationDetails.checkedIn ?   <div className='mt-3'>
               <div className="h-[56px] bg-[#211f52] rounded-[8px] flex pt-[12px] pb-[12px] pl-[13px] pr-[13px] justify-between items-center">
                <p className="text-[13.88px] font-semibold leading-[16.92px] text-left ">Wifi Password </p>
                <div className="w-[60%] rounded-[23px] bg-[#383849] h-[32px] flex items-center pl-[12px] pr-[12px] justify-between">
                  <span class="font-[Montserrat] text-[13px] font-medium leading-[15.85px]  w-[190px] truncate">
                  {hotelDetails.wifiPassword}
                  </span>
                 {/* <span className=" cursor-pointer"  >Copy</span> */}
                 <span class="text-xs font-normal text-[white] cursor-pointer select-none pl-[15px]" onClick={handleCopyClick}>{isCopied ? 'Copied!' : 'Copy'}</span>

                </div>

               </div>
           </div> : ''}

         
     <div className='mt-3'>
      {promotionList?.length > 0 && <PromotionList promotionList={promotionList} menuVisibility={menuVisibility} />}
     </div>
            <div
              // className="service-head mt-9"
              className='service-head mt-5 '
              // {
              //   (chechOutLocalStorage|| reservationDetails.checkedIn)
              //     ? "service-head"
              //     : "service-head pt-12" //pt-12
              // }
            >
              Services
            </div>
            {!reservationDetails.checkedIn && (
              <div className="flex items-center gap-4 mt-3 mb-4">
                <Earlymenu showEarly={() =>handleEarlyCheckinStatus()} />
                <ManageDoc open={() => setShowModal(true)} />
              </div>
            )}
          </div>

          {showModal && (
            <DocModal doc={docsToUpload} isUploaded={isDocUploaded} hide={() => setShowModal(false)} />
          )}
          {showEarlyCheckin && (
            <EarlyCheckin
              bookingParams={bookingParams}
              earlyTimeArray={earlyTimeArray}
              hide={() => setShowEarlyCheckin(false)}
              is_editStatus = {false}
            />
          )}
          {orderHostory && (
            <OrderHistory
              bookingParams={bookingParams}
              hide={() => setOrderHostory(false)}
            />
          )}
          {showCheckOut && <CheckoutForm hide={() => { setShowCheckOut(false); }} setCheckorNot={() => { setchechOutLocalStorage(true) }} setCheckOutConfirmation={() => { setCheckOutConformation(true) }} />}

          <div className="pb-28 section-wrap  menu-container relative overflow-y-auto"    >
            {/* <div className="serve">Services</div> */}
            {reservationDetails.checkedIn && 
              <>
                {showArrow && (
                  <div className=" fixed w-[35px] h-[35px] z-10 bottom-4 left-1/2 transform -translate-x-1/2 flex justify-center items-center">
                    <div  onClick={scrollToBottom}
                      className="w-[100%] h-[100%] rounded-full bg-[white] flex justify-center items-center cursor-pointer"    
                    >
                       <img className="w-7 relative bottom-[2px]" src={ScrollDown}></img>
                    </div>
                    </div>
                  )}
              </>
            } 
            <div className="grid grid-flow-row grid-cols-2  gap-5 mt-3"   >
              <Link
                 onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                 to={chechOutLocalStorage ? "#" : '/spot-my-room'}
                 className="homeBox relative h-[90px]"
                style={{
                  background: `url(${RoomImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute top-2 left-2 ">
                  <div className="menu-head">My Room</div>
                  <div className="menu-label">Details of your room</div>
                </div>
              </Link>
              {menuVisibility?.IsPickup ?

                <Link
                  onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                  to={chechOutLocalStorage ? "#" : '/pick-and-drop/' + HotelGuidId.hotelId}
                  state={HotelGuidId}
                  className="homeBox relative overflow-hidden h-[90px]"
                  style={{
                    background: `url(${PickImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-2 left-2 ">
                    <div className="menu-head" style={{ color: "#fff" }}>
                      Pick & Drop{" "}
                    </div>
                    <div className="menu-label" style={{ color: "#fff" }}>
                      Book your taxi
                    </div>
                  </div>
                </Link> : null}
              {console.log(menuVisibility?.IsIndoorDining)}
              {menuVisibility?.IsIndoorDining ? (
                <Link
                  onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                  to={chechOutLocalStorage ? "#" : "/resturants/" + HotelGuidId.hotelId}
                  className="homeBox overflow-hidden relative  h-[90px]"
                  style={{
                    background: `url(${InroomImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-2 left-2 ">
                    <div className="menu-head" style={{ color: "#fff" }}>
                      Inroom Dining
                    </div>
                    <div className="menu-label" style={{ color: "#fff" }}>
                      Order to your room
                    </div>
                  </div>
                </Link>
              ) : null}
              {menuVisibility?.IsTable ? <Link
                onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                to={chechOutLocalStorage ? "#" : "/table-reservation/" + HotelGuidId.hotelId}
                className="homeBox overflow-hidden relative  h-[90px]"
                style={{
                  background: `url(${TableImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute top-2 left-2 ">
                  <div className="menu-head">Table Reservation</div>
                  <div className="menu-label">Reserve your tables</div>
                </div>
              </Link> : null}
              {isCheckin && menuVisibility?.IsHouseKeeping ?
                <Link
                  onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                  to={chechOutLocalStorage ? "#" : "/house-keeping/" + HotelGuidId.hotelId}
                  state={HotelGuidId}
                  className="homeBox overflow-hidden relative h-[90px]"
                  style={{
                    background: `url(${HkImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-2 left-2 ">
                    <div className="menu-head" style={{ color: "#fff" }}>
                      House-Keeping
                    </div>
                    <div className="menu-label" style={{ color: "#fff" }}>
                      Request Service
                    </div>
                  </div>
                </Link>
                : null}
              <Link
                 onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                 to={chechOutLocalStorage ? "#" : "/hotel-guide/" + HotelGuidId.hotelId}
                state={HotelGuidId}
                className="homeBox overflow-hidden relative  h-[90px]"
                style={{
                  background: `url(${HotelGuideImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute top-2 left-2 ">
                  <div className="menu-head">Hotel Guide </div>
                  <div className="menu-label">A-Z Details of hotel</div>
                </div>
              </Link>
              {menuVisibility?.IsEvent ?
                <Link
                  onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                  to={chechOutLocalStorage ? "#" : "/event/" + HotelGuidId.hotelId}
                  state={HotelEvent}
                  className="homeBox overflow-hidden relative h-[90px]"
                  style={{
                    background: `url(${EventImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-2 left-2 ">
                    <div className="menu-head" style={{ color: "#fff" }}>
                      Events{" "}
                    </div>
                    <div className="menu-label" style={{ color: "#fff" }}>
                      Book Your Event Tickets
                    </div>
                  </div>
                </Link> : null}
              <Link
                onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                // to={chechOutLocalStorage ? "#" : "/event/" + HotelGuidId.hotelId}
                to={chechOutLocalStorage ? "#" : "/tourist-guide/" + HotelGuidId.hotelId}
                state={{TouristGuide:TouristGuide, menuVisibility:menuVisibility}}
                className="homeBox overflow-hidden relative h-[90px]"
                style={{
                  background: `url(${TouristImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute top-2 left-2 ">
                  <div className="menu-head">Tourist Guide</div>
                  <div className="menu-label">Explore the nearby places</div>
                </div>
              </Link>
              {menuVisibility?.IsSpa  ? (
                <Link
                  onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                  to={chechOutLocalStorage ? "#" : "/spa/" + HotelGuidId.hotelId}
                  className="homeBox overflow-hidden relative h-[90px]"
                  style={{
                    background: `url(${SpaImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-2 left-2 ">
                    <div className="menu-head" style={{ color: "#fff" }}>
                      Spa
                    </div>
                    <div className="menu-label" style={{ color: "#fff" }}>
                      Book Your spa services
                    </div>
                  </div>
                </Link>
              ) : null}
            </div>
            
            {reservationDetails.checkedIn && (
              <div>
                <div className="mt-6 serve">Other Services</div>
                <div className="grid grid-flow-row grid-cols-4 gap-4 mt-5">
                <ManageDoc open={() =>{ if(chechOutLocalStorage){
                                       setckeckOutConModal(true)
                                      }else{
                                        setShowModal(true);
                                        setckeckOutConModal(false)
                                      }
                                }} checkinPage/>

                  <Link
                    onClick={() => handleRoomChangeCheck()}
                    to={(chechOutLocalStorage|| requestStatus?.roomChange) ? "#" : "../room-change"} className="homeBox">
                    <div className="otherServ">
                      <img src={RoomChangeImg} alt="" />
                      <div className="pt-1">Room change</div>
                    </div>
                  </Link>
                  <a
                    href={`tel:${hotelDetails.departmentNumbers[0].contactNumber}`}
                    className="homeBox"
                  >
                    <div className="otherServ">
                      <img src={ReceptionImg} alt="" />

                      <div className="  pt-1">Reception</div>
                    </div>
                  </a>
                  <Link
                    onClick={() => { chechOutLocalStorage ? setckeckOutConModal(true) : setckeckOutConModal(false) }}
                    to={chechOutLocalStorage ? "#" : "../wakeup-call"}
                    href="wakeup-call"
                    className="homeBox"
                  >
                    <div className="otherServ">
                      <img src={WakeCpImg} alt="" />
                      <div className="pt-1">Wake up call</div>
                    </div>
                  </Link>
                  <div className="homeBox" onClick={handleFeedback}>
                    <div className="otherServ">
                      <img src={FeedBackImg} alt="" />
                      <div className="pt-1">Feedback</div>
                    </div>
                  </div>


                  <Link
                    onClick={() =>handleExtendStayStatus()}
                    to={(chechOutLocalStorage|| requestStatus?.extendStay) ? "#" : "/extend-stay"} className="homeBox">
                    <div className="otherServ">
                      <img src={ExtendImg} alt="" />
                      <div className="pt-1">Extend Stay</div>
                    </div>
                  </Link>
                  <button
                    onClick={() =>{ chechOutLocalStorage ? setckeckOutConModal(true) : setShowCheckOut(true)}}
                    className="homeBox otherServ"
                  >
                       <img src={CheckoutImg} alt="" />
                      <div className="pt-1">Check-out</div>
                  </button>
                </div>
              </div>
            )}
            
          </div>
          {IsFeedbck && <FeedBack hide={() => SetIsFeedback(false)} />}
        </div>
      ) : (
        <Skeleton type="page" />
      )}
      {hasBooking == "No bookings found for this bookingId." && (
        <RedirectModal />
      )}

      <CheckOutSuccess
        isOpen={checkOutConformation}
        onClose={handleCloseCheckOutSuccess}
        heading="Successfully Requested!"
      />
      <CheckOutSuccess
        isOpen={ckeckOutConModal}
        onClose={handleCloseConModal}
        heading="Service Request Unavailable: You are currently in the checkout process and cannot request additional services at this time.!"
      />
      {requestStatusPopup && <RequestCheckAlert heading={statusHeading} onClose={()=>setRequestStatusPopup(false)}/>}
    </div>
  );
}

export default Home;
